var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stars__rating"},[_c('div',{staticClass:"stars_outer"},[_c('div',{staticClass:"stars_inner",style:({width: _vm.percentage})})])])
}
var staticRenderFns = []

export { render, staticRenderFns }